var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"style":{"fill":"#001953"},"d":"M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27\r\n\t\tc-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0\r\n\t\tL17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z"})));
}

Checkmark.defaultProps = {"height":"800px","width":"800px","version":"1.1","id":"Capa_1","viewBox":"0 0 17.837 17.837","xmlSpace":"preserve"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
